var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.type === 'circular')?_c('v-progress-circular',{attrs:{"size":_vm.size,"color":_vm.color,"indeterminate":_vm.indeterminate}}):(_vm.type === 'linear')?_c('v-progress-linear',{attrs:{"height":_vm.size,"color":_vm.color,"indeterminate":_vm.indeterminate}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }